import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader, Table} from "reactstrap";
import Lightbox from "react-image-lightbox";
import Button from "../../../Button";

const ImageZoom = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  return <React.Fragment>
    <img className="cursor-pointer" src={props.rawTool?.ImageName} style={{ maxHeight: 50 }} onClick={() => setIsOpen(true)} />
    {isOpen && <Lightbox
      mainSrc={props.rawTool?.ImageName}
      imageTitle={<span>{props.rawTool.RawToolName} ({props.rawTool.RawToolNumber})</span>}
      nextSrc={null}
      prevSrc={null}
      onCloseRequest={() => setIsOpen(false)}
    />}
  </React.Fragment>
}

const RawToolsModal = ({rawToolsData, onClose}) => {
  return <Modal isOpen size="lg" toggle={onClose}>
    <ModalHeader toggle={onClose}>{[rawToolsData.ItemMpText, rawToolsData.KorText].join(' ')}</ModalHeader>
    <ModalBody>
      <Table className="table-bordered">
        <thead>
        <tr>
          <th>Nazwa narzędzia</th>
          <th>Indeks</th>
        </tr>
        </thead>
        <tbody>
        {rawToolsData.RawTools.map((rawTool, key) => <tr key={key.toString()}>
          <td>
            <ImageZoom rawTool={rawTool} />
            <span className="ml-3">{rawTool.RawToolName}</span>
          </td>
          <td>{rawTool.RawToolNumber}</td>
        </tr>)}
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>Zamknij</Button>
    </ModalFooter>
  </Modal>;
};

RawToolsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  rawToolsData: PropTypes.shape({
    ItemMpText: PropTypes.string.isRequired,
    KorText: PropTypes.string,
  }).isRequired,
};

export default RawToolsModal;